import HubSpecificFreeFeaturesMap from 'self-service-api/constants/HubSpecificFreeFeaturesMap';
import ProductLineMap from 'self-service-api/constants/ProductLineMap';
import * as ApiNames from 'self-service-api/constants/ApiNames';
import { ApiNameToFeaturesMap } from 'self-service-api/constants/ApiNameToFeaturesMap';
import { productLineToHub } from 'self-service-api/constants/ProductLineToHub';
export const getFeaturesForProduct = (apiName, productLine) => {
  if (apiName === ApiNames.HUBSPOT_FREE) {
    return HubSpecificFreeFeaturesMap[productLineToHub[productLine]];
  } else {
    return ApiNameToFeaturesMap[apiName];
  }
};
export const getHighlightsForProductLine = productLine => {
  const {
    highlightedFreeProduct,
    highlightedPaidProducts
  } = ProductLineMap[productLine];
  return [...(highlightedFreeProduct ? [highlightedFreeProduct] : []), ...highlightedPaidProducts];
};
export const getAllProductLevels = productInfo => {
  const {
    productMap,
    productLine
  } = productInfo;

  if (productLine && productMap) {
    return getHighlightsForProductLine(productLine).map(apiName => {
      const productKey = Object.keys(productMap).find(key => productMap[Number(key)].apiName === apiName);
      const product = productMap[Number(productKey)];
      return product && product.productLevel && product.productLevel;
    });
  }

  return [];
};

const getAllEditionsFromProduct = (productLine, productMap) => {
  return getAllProductLevels({
    productLine,
    productMap
  }).map(productLevel => productLevel.toLowerCase());
};

export const getAllEditionsForHub = productInfo => {
  const {
    productMap,
    productLine
  } = productInfo;

  if (productMap && productLine) {
    return getAllEditionsFromProduct(productLine, productMap);
  }

  return [];
};
export const getCurrentFeatures = ({
  productLine,
  activeColumn
}) => {
  const highlights = getHighlightsForProductLine(productLine);
  return getFeaturesForProduct(highlights[activeColumn], productLine);
};